import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { postPAIAE010Choice, postPAIAE010DelChoice, postPAJAD010Accept } from '../../services/Api';
import { decodeToken, formatDate } from '../../utils';
import Dropdown from './Dropdown';
const CandidateItem = ({
    item,
    handleChangeDropdown,
    handleInputChange,
    handleDelete,
    refreshData,
    setPopupSendMailOpen,
    setReceiver,
    getListData,
    payload,
    handleSave,
}) => {
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [star, setStar] = useState(false);
    useEffect(() => {
        if (item.isChoice === 'Y') {
            setStar(true);
        } else {
            setStar(false);
        }
    }, [item]);
    const getStatusFlag = (status) => {
        switch (status) {
            case 'K':
                return '보관';
            case 'O':
                return '진행';
            case 'C':
                return '기간마감';
            case 'E':
                return '기간마감';
            case 'D':
                return '삭제';
            case 'P':
                return '입금대기';
            case 'V':
                return '승인대기';
            case 'W':
                return '등록대기';
            case 'X':
                return '미결제삭제';
            case 'J':
                return '승인거절';
            default:
                return '';
        }
    };

    const removeStar = (item) => {
        setStar(false);
        postPAIAE010DelChoice(item?.choiceSeq)
            .then(() => {
                if (refreshData) refreshData();
            })
            .catch((error) => {
                setStar(true);
                console.log(error);
            });
    };

    const activeStar = (item) => {
        setStar(true);
        postPAIAE010Choice({ tblName: 'Resume', refSeq: item?.resSeq, memberID: decode?.memberID })
            .then(() => {
                if (refreshData) refreshData();
            })
            .catch((error) => {
                setStar(true);
                console.log(error);
            });
    };

    const handleSendLetter = (resMemberID, resName) => {
        setPopupSendMailOpen(true);
        setReceiver({ id: resMemberID, name: resName });
    };

    const handlePopup = async (item) => {
        if (item.acceptYN === 'N') {
            await postPAJAD010Accept(item.seq);
            await getListData();
        }
    };

    const isCancelled = item?.resCancel === 'Y' || item?.resDel === 'Y';

    // snapYn === 'Y' -> xem bản snapshot của hồ sơ (dùng seq của ứng tuyển), ngược lại xem hồ sơ gốc (resSeq)
    const resumeParam = item?.snapYn === 'Y' ? `${item?.seq}?snap=Y` : `${item?.resSeq}`;

    return (
        <div className="cndd">
            <div className="cndd__block" key={`cndd-${item.seq}`}>
                <div
                    className="cndd__top"
                    style={{ background: isCancelled ? '#dddddd4d' : item?.acceptYN === 'N' ? '#f0f7fd' : '' }}
                >
                    <div className="cndd__info">
                        <div className="cndd__name">
                            {item?.resName}
                            {!isCancelled && (
                                <img
                                    src="./images/icons/icon-letter-blk.png"
                                    alt="icon letter"
                                    className="pointer"
                                    onClick={() => handleSendLetter(item?.resMemberID, item?.resName)}
                                />
                            )}
                        </div>
                        <div className="cndd__cntn">
                            {isCancelled ? (
                                item?.resTitle
                            ) : (
                                <>
                                    <Link
                                        onClick={async () => {
                                            if (item.acceptYN === 'N') {
                                                await postPAJAD010Accept(item.seq);
                                            }
                                        }}
                                        to={`/pafaa060-${resumeParam}`}
                                    >
                                        {item?.resTitle}
                                    </Link>

                                    <div className="table">
                                        <div className="wrap-meta">
                                            <button
                                                className={`icon icon-star ${star ? 'active' : ''}`}
                                                onClick={star ? () => removeStar(item) : () => activeStar(item)}
                                            />
                                            <Link
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(
                                                        `/pafaa061-${resumeParam}`,
                                                        '_blank',
                                                        'width=1335,height=1000',
                                                    );
                                                    handlePopup(item);
                                                }}
                                            >
                                                <i className="icon icon-blank" />
                                            </Link>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <ul className="cndd__list">
                            <li className="cndd__item">
                                {item?.resumeCareer !== null && item?.resumeCareer === '009'
                                    ? `경력(${item?.resumeCareerYear})`
                                    : `신입`}
                            </li>
                            <li className="cndd__item">{item?.resumeForm}</li>
                            <li className="cndd__item">
                                {item?.resumeRegionSi1} {item?.resumeRegionGu1}
                            </li>
                        </ul>
                    </div>

                    <div className="cndd__date">
                        <span>지원일 : {formatDate(item?.applyDate)}</span>
                        <span>{item?.acceptYN === 'Y' ? `열람일: ${formatDate(item?.acceptDate)}` : '미열람'}</span>
                    </div>
                    {isCancelled ? (
                        <div className="cndd__end">
                            <span className="cndd__yn" style={{ color: 'red', fontWeight: '600' }}>
                                지원취소
                            </span>
                        </div>
                    ) : (
                        <>
                            <div
                                className={`cndd__end ${item?.resCancel === 'N' && item?.result === 'W' ? 'cndd__end-block' : ''
                                    } `}
                            >
                                <div className="cndd__select">
                                    <div
                                        className="form-select-container"
                                        style={{ background: item?.acceptYN === 'N' ? '#f0f7fd' : '' }}
                                    >
                                        <div
                                            className="cndd__end"
                                            style={{
                                                display:
                                                    item?.resCancel === 'N' && item?.result === 'W' ? 'unset' : 'flex',
                                            }}
                                        >
                                            {item?.resCancel === 'N' ? (
                                                item?.result === 'W' ? (
                                                    <>
                                                        <Dropdown
                                                            placeholder="결과 대기"
                                                            options={[
                                                                {
                                                                    value: 'P',
                                                                    option: '합격',
                                                                },
                                                                {
                                                                    value: 'F',
                                                                    option: '불합격',
                                                                },
                                                            ]}
                                                            value={payload[item?.seq]?.status || ''}
                                                            name={`status-` + item?.seq}
                                                            id={`status-` + item?.seq}
                                                            className="cndd__select"
                                                            onChange={handleChangeDropdown}
                                                        />
                                                        <Dropdown
                                                            placeholder="사유 선택"
                                                            options={[
                                                                {
                                                                    value: '면접불참',
                                                                    option: '면접불참',
                                                                },
                                                                {
                                                                    value: '연락두절',
                                                                    option: '연락두절',
                                                                },
                                                                {
                                                                    value: '직접입력',
                                                                    option: '직접입력',
                                                                },
                                                            ]}
                                                            name={`reason-type-` + item?.seq}
                                                            id={`reason-type-` + item?.seq}
                                                            className="cndd__select"
                                                            onChange={handleChangeDropdown}
                                                            value={payload[item?.seq]?.reasonType}
                                                            disabled={payload[item?.seq]?.result !== 'F'}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="cndd__input"
                                                            name={`reason-${item?.seq}`}
                                                            onChange={handleInputChange}
                                                            placeholder="사유입력"
                                                            readOnly={payload[item?.seq]?.reasonType !== '직접입력'}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="rsm-stt__btn"
                                                            onClick={() => handleSave(item)}
                                                        >
                                                            저장
                                                        </button>
                                                    </>
                                                ) : item?.result === 'P' ? (
                                                    <span className="cndd__yn cndd__yn--y">합격</span>
                                                ) : item?.result === 'F' ? (
                                                    <>
                                                        <span className="cndd__yn">불합격</span>
                                                        <span className="cndd__yn">{item?.reason}</span>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            ) : (
                                                <span className="cndd__yn">지원포기</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button" className="cndd__delete" onClick={() => handleDelete(item)}>
                                <i className="icon icon-trash-2"></i>
                            </button>
                        </>
                    )}
                </div>
                <div className="cndd__bottom">
                    <div className="cndd__lf">
                        <span className="blue">
                            {item?.recStatusFlag
                                ? getStatusFlag(item.recStatusFlag)
                                : getStatusFlag(item.recStatusFlagHist)}
                        </span>
                        <span>{item?.recTitle}</span>
                        <span className="date">
                            {formatDate(item?.recRecruitFrom)}~{formatDate(item?.recRecruitEnd)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CandidateItem;
